import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon, MailIcon, PhoneIcon } from 'lucide-react';
import { company } from '../data/company';
import { quickOrderMailto, whatsappLink } from '../utils/contact';
const links = [{
  to: '/',
  label: 'Home'
}, {
  to: '/commodities',
  label: 'Commodities'
}, {
  to: '/live-orders',
  label: 'Live Orders'
}, {
  to: '/about',
  label: 'About'
}, {
  to: '/contact',
  label: 'Contact'
}];
export function Header() {
  const [open, setOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [pathname]);
  return <header className="sticky top-0 z-40 border-b border-hair bg-ink/95 backdrop-blur" data-id="element-115" data-mp="36b208j2jttst">
      <div className="hidden border-b border-hair/60 lg:block" data-id="element-116" data-mp="36cwa92ca81i4">
        <div className="mx-auto flex max-w-shell items-center justify-between px-6 py-2 text-xs text-muted" data-id="element-117" data-mp="3bbfvf0j1x99f">
          <p className="font-mono uppercase tracking-[0.18em]" data-id="element-118" data-mp="3fc9ixssl0m1s">
            Mining &amp; Trading Company · Established {company.established} · Lubumbashi, D.R. Congo
          </p>
          <div className="flex items-center gap-6" data-id="element-119" data-mp="2rkq91ctbl4ka">
            <a className="flex items-center gap-2 transition-colors duration-150 hover:text-gold-light" href={`mailto:${company.email}`} data-id="element-120" data-mp="2mmooeng8wx6p">
              <MailIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-121" data-mp="2hpoiccjebufl" />
              {company.email}
            </a>
            <a className="flex items-center gap-2 transition-colors duration-150 hover:text-gold-light" href={whatsappLink()} target="_blank" rel="noreferrer" data-id="element-122" data-mp="3fd6rhogyyyk4">
              <PhoneIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-123" data-mp="30mzcxju31zop" />
              Chat on WhatsApp
            </a>
          </div>
        </div>
      </div>

      <div className="mx-auto flex max-w-shell items-center justify-between gap-6 px-6 py-4" data-id="element-124" data-mp="1yirs6krdwif">
        <Link to="/" className="flex items-center gap-3" aria-label={`${company.name} home`} data-id="element-125" data-mp="3t90md3kwrne8">
          <img src={company.logo} alt="" className="h-14 w-14 object-contain" data-id="element-126" data-mp="1recvthxgixl1" />
          <span className="hidden sm:block" data-id="element-127" data-mp="1wbcwfdbjf84r">
            <span className="block font-display text-xl leading-none tracking-wide text-bone" data-id="element-128" data-mp="1hnrq7ajd8ssm">
              LUMUMBASHI
            </span>
            <span className="block font-mono text-[10px] uppercase tracking-[0.32em] text-gold" data-id="element-129" data-mp="1mltbm249l479">
              Minerals SPRL
            </span>
          </span>
        </Link>

        <nav aria-label="Primary" className="hidden items-center gap-8 lg:flex" data-id="element-130" data-mp="1cp6qdc810b4p">
          {links.map(link => <NavLink key={link.to} to={link.to} end={link.to === '/'} className={({
          isActive
        }) => `relative py-1 text-sm font-medium transition-colors duration-150 ${isActive ? 'text-gold-light' : 'text-bone/80 hover:text-bone'}`} data-id="element-131" data-mp="ypxlv9t6n5gk">
              {({
            isActive
          }) => <>
                  {link.label}
                  {isActive && <span className="absolute -bottom-0.5 left-0 h-px w-full bg-gold" aria-hidden="true" data-id="element-132" data-mp="hgcwuwrmr94s" />}
                </>}
            </NavLink>)}
        </nav>

        <div className="flex items-center gap-3" data-id="element-133" data-mp="rcpzik55kxbo">
          <a href={quickOrderMailto()} className="hidden rounded-sm bg-gold px-5 py-2.5 text-sm font-semibold text-ink transition-colors duration-150 hover:bg-gold-light sm:inline-block" data-id="element-134" data-mp="rbwo35v91jn7">
            Place an Order
          </a>
          <button type="button" onClick={() => setOpen(v => !v)} className="rounded-sm border border-hair p-2.5 text-bone transition-colors duration-150 hover:border-gold lg:hidden" aria-expanded={open} aria-label={open ? 'Close menu' : 'Open menu'} data-id="element-135" data-mp="1f20q58sshbc3">
            {open ? <XIcon className="h-5 w-5" data-id="element-136" data-mp="3bxyjjck81zew" /> : <MenuIcon className="h-5 w-5" data-id="element-137" data-mp="22z6waistyjit" />}
          </button>
        </div>
      </div>

      {open && <nav aria-label="Mobile" className="border-t border-hair bg-panel lg:hidden" data-id="element-138" data-mp="27wyyq6r3po19">
          <div className="mx-auto max-w-shell px-6 py-4" data-id="element-139" data-mp="2cwbjmlyewl17">
            {links.map(link => <NavLink key={link.to} to={link.to} end={link.to === '/'} className={({
          isActive
        }) => `block border-b border-hair/60 py-3 text-sm ${isActive ? 'text-gold-light' : 'text-bone/85'}`} data-id="element-140" data-mp="2gy6m3ts2x4gk">
                {link.label}
              </NavLink>)}
            <a href={quickOrderMailto()} className="mt-4 block rounded-sm bg-gold px-5 py-3 text-center text-sm font-semibold text-ink" data-id="element-141" data-mp="1xzu6pqakqycj">
              Place an Order
            </a>
          </div>
        </nav>}
    </header>;
}